import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input} from '@angular/core';
import {dialectSelectId, GetRegion2Css, GetRegion2Name} from "../../defines/client.const";
import {SimpleDialect} from "../../models/dialect.model";
import {IsEmptyString} from "../../defines/common.func";

@Component({
  selector: 'app-dialect-item',
  templateUrl: './dialect-item.component.html',
  styleUrls: ['./dialect-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialectItemComponent implements AfterViewInit {
  @HostBinding('style.display') styleBlock = 'block';
  @Input() dialect: SimpleDialect;
  @Input() select = false;

  public readonly dialectSelectId = dialectSelectId;
  protected readonly GetRegion2Name = GetRegion2Name;
  protected readonly GetRegion2Css = GetRegion2Css;

  constructor(
    private elRef: ElementRef,
  ) { }

  ngAfterViewInit(): void {
    this.dialect.offsetTop = this.elRef.nativeElement.offsetTop;
  }

  public get briefMeaning(): string {
    return this.dialect?.meaning2.filter(m => !IsEmptyString(m)).join(', ') ?? '';
  }
}
